import StoreLocatorDetailTemplate from '@components/templates/StoreLocatorDetailTemplate/StoreLocatorDetailTemplate'
import { RivenditoreStoreLocatorDocument } from '@gql/graphql-get'
import { grapheneGet } from '@utils/index'
import { NextWrapper } from 'data-fetching-wrapper'
import { print } from 'graphql'

const RivenditoreDetail = ({ pagina, rivenditore }) => {
  return <StoreLocatorDetailTemplate pagina={pagina} rivenditore={rivenditore} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/store-locator/dealer/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const variables = {
      slug: slug,
    }
    const encodedVariablesRivenditori = encodeURIComponent(JSON.stringify(variables))

    const encodedQueryRivenditori = encodeURIComponent(print(RivenditoreStoreLocatorDocument))

    const responseRivenditore = await grapheneGet.get(
      `?lang=${locale}&query=${encodedQueryRivenditori}&operationName=RivenditoreStoreLocator&variables=${encodedVariablesRivenditori}`
    )

    const rivenditore = responseRivenditore?.data?.data?.rivenditoreStoreLocator
    if (!rivenditore) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        pagina: rivenditore?.pagina,
        rivenditore: rivenditore,
        key: null,
      },
      revalidate: 60 * 20,
    }
  },
  '/[slug]'
)

export default RivenditoreDetail
